import React, { useState } from 'react';
import { IoSend } from 'react-icons/io5';

const ChatMessageInputContainer = ({ onSendMessage }) => {
  const [newMessage, setNewMessage] = useState('');

  const handleSendMessage = async () => {
    const trimmedMessage = newMessage.trim();
    if (!trimmedMessage) return;
    if (trimmedMessage.length > 300) {
      alert('메시지는 300자를 초과할 수 없습니다.');
      return;
    }

    try {
      await onSendMessage(trimmedMessage);
      setNewMessage('');

      const textarea = document.querySelector('textarea');
      if (textarea) {
        textarea.style.height = 'auto';
        textarea.style.height = '24px';
      }
    } catch (error) {
      console.error('메시지 전송 실패:', error);
      alert('메시지 전송에 실패했습니다.');
    }
  };

  return (
    <div className="bg-white border-t border-gray-200 px-4 py-3">
      <div className="flex items-end space-x-2">
        <div className="flex-1 min-h-[40px] max-h-[192px] bg-gray-100 px-4 py-2 flex items-center relative">
          <textarea
            value={newMessage}
            onChange={(e) => {
              if (e.target.value.length <= 300) {
                setNewMessage(e.target.value);
              }
            }}
            placeholder="메시지를 입력하세요"
            className="flex-1 bg-transparent resize-none outline-none text-sm pr-12"
            rows={1}
            style={{
              fontSize: '16px',
              minHeight: '24px',
              maxHeight: '192px',
              lineHeight: '24px',
              overflow: 'hidden',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none'
            }}
            onInput={(e) => {
              e.target.style.height = 'auto';
              e.target.style.height = Math.min(e.target.scrollHeight, 192) + 'px';
            }}
          />
          <div className="absolute right-2 bottom-1 text-xs text-gray-400">
            {newMessage.length}/300
          </div>
        </div>

        <button
          onClick={handleSendMessage}
          disabled={!newMessage.trim()}
          className={`p-2 ${
            newMessage.trim() 
              ? 'text-amber-500 active:text-amber-600' 
              : 'text-gray-400'
          }`}
        >
          <IoSend size={20} />
        </button>
      </div>
    </div>
  );
};

export default ChatMessageInputContainer;
